export { default } from './Dialog';